document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-nearest-trial-registration]')
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

  const forms = Array.from(document.querySelectorAll('[data-trial-registration-inline]'))
    .filter((form) => form.getClientRects().length > 0)
  if (!forms.length) return

  const linkRect = link.getBoundingClientRect()
  const linkCenter = linkRect.top + linkRect.height / 2
  const distance = (form) => {
    const rect = form.getBoundingClientRect()
    return Math.max(rect.top - linkCenter, linkCenter - rect.bottom, 0)
  }
  const nearest = forms.reduce((closest, form) => distance(form) < distance(closest) ? form : closest)

  link.hash = nearest.id
  nearest.focus({ preventScroll: true })
})
